/* eslint-disable */
import Vue from 'vue'
import Router from 'vue-router'
import routes from './routes'
import beforeEach from './beforeEach'
import afterEach from './afterEach'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  saveScrollPosition: true,
  scrollBehavior: () => ({ y: 0 }),
  routes,
})

const { checkRoute, doChecks } = beforeEach(router, routes)
afterEach(router)

export { checkRoute, doChecks, router }



// WEBPACK FOOTER //
// ./src/router/index.js